import { call, put, takeLatest } from '@redux-saga/core/effects';
import * as types from '../../actions/shopList/shopActionTypes';
import reservationService from '../../services/reservationService';

function* fetchOneShopSaga(action: any): Generator<unknown> {
  try {
    const response: any = yield call(reservationService().getOneClub, action);
    if (response.data.result === 0) {
      // 转换店铺数据格式
      const club = response.data.club_information;
      const shop = {
        id: club.club_id.toString(),
        name: club.club_name,
        image: club.club_picture || '/assets/img/store-image.jpg',
        preOpenDay: club.pre_open_day,
        businessHours: club.open_date,
        phone: club.telephone,
        address: `${club.post_id ? `〒${club.post_id}` : ''} ${club.address}${
          club.addr_buildname ? ` ${club.addr_buildname}` : ''
        }`,
        annexOpenDate: club.annex_flag ? club.annex_open_date : '',
        annexAddress:
          club.annex_flag &&
          `${club.annex_post_id ? `〒${club.annex_post_id}` : ''} ${club.annex_address}${
            club.annex_addr_buildname ? ` ${club.annex_addr_buildname}` : ''
          }`,
        features: (club.tag_list || []).map((tag: any) => ({
          id: tag.tag_id.toString(),
          name: tag.tag_name,
          icon: tag.thumbnail_image || '/assets/img/default-icon',
          category: 'facility' as const, // 根据 tag_manage 区分 facility/service
        })),
        isBookmarked: false,
        latitude: parseFloat(club.latitude),
        longitude: parseFloat(club.longitude),
        webRegistrationOpenDay: club.web_registration_open_day,
      };
      yield put({
        type: types.GET_VISITOR_CLUB_DETAIL_SUCCESS,
        data: shop,
      });
    } else {
      throw new Error('API returned error result');
    }
  } catch (error: any) {
    yield put({
      type: types.GET_VISITOR_CLUB_DETAIL_FAILURE,
      data: null,
    });
  }
}

export function* shopSaga(): Generator<unknown> {
  yield takeLatest(types.GET_VISITOR_CLUB_DETAIL_REQUEST, fetchOneShopSaga);
}

export default shopSaga;
